import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IUpdateUserEducationApiPayload,
  TUpdateUserEducationApiResponse,
} from '../types/UpdateOffice.api';
import { withOfficeOverride, type IOfficeOverrideOptions } from './officeOverride';

export const updateUserEducation = async (
  payload: IUpdateUserEducationApiPayload,
  options?: IOfficeOverrideOptions,
): Promise<TUpdateUserEducationApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<TUpdateUserEducationApiResponse>(
    '/credential-service/user/credentials',
    payload,
    { headers: withOfficeOverride(headers, options) },
  );
  return data;
};
